import { isAxiosError } from "axios";
import saveAs from "file-saver";
import i18n, { t } from "i18next";
import axios from "../lib/axios";
import { Project } from "../types";

export async function updateUserRole(
  employeeId: number,
  companyId: number,
  role: string,
) {
  try {
    const response = await axios.put(
      `/api/user-role`,
      {
        employeeId,
        companyId,
        role,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message: response.data.message || "Role updated succesfull.",
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchRoles() {
  try {
    const response = await axios.get(`/api/roles`, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchUserManagers(employeeId: number, companyId: number) {
  try {
    const response = await axios.get(`/api/manager/user-managers`, {
      params: {
        employeeId,
        companyId,
      },
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchManagers(companyId?: number) {
  try {
    const params = companyId && companyId > 0 ? { companyId } : {};

    const response = await axios.get(`/api/managers`, {
      params,
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function updateIsManager(employeeId: number, companyId: number) {
  try {
    const response = await axios.put(
      `/api/change-manager-status`,
      {
        employeeId,
        companyId,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      message: response.data.message || t("Successful update."),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchHourlySummary(
  companyId: number,
  // pageSize: number,
  // pageNumber: number,
  month: string,
) {
  try {
    const response = await axios.get(`/api/hourly-summary`, {
      params: {
        companyId,
        // pageSize,
        // pageNumber,
        month,
      },
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchHourlySummaryByApp(
  companyId: number,
  month: string,
) {
  try {
    const response = await axios.get(`/api/hourly-summary/by-app`, {
      params: {
        companyId,
        month,
      },
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function exportHourlySummaryByAppToXlsx(
  companyId: number,
  month: string,
): Promise<void> {
  try {
    const response = await axios.get<Blob>(
      `/api/hourly-summary/by-app/export-xls`,
      {
        headers: {
          "Accept-Language": i18n.language,
        },
        params: {
          companyId,
          month,
        },
        responseType: "blob",
      },
    );

    const fileName = `PodsumowanieNaPodstawieAplikacji_${new Date().toISOString().split("T")[0]}.xlsx`;
    saveAs(
      new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      fileName,
    );
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data instanceof Blob) {
          try {
            const asText = await error.response.data.text();
            const parsed = JSON.parse(asText);
            if (parsed && typeof parsed === "object" && "message" in parsed) {
              message = String(parsed.message);
            }
          } catch {
            // ignoruj
          }
        } else if (
          error.response.data &&
          "message" in error.response.data
        ) {
          message = error.response.data.message;
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
}

export async function fetchHeadManagersForManager(
  headManagerId: number,
  companyId: number,
) {
  try {
    const response = await axios.get(
      `/api/users/headmanagers/${headManagerId}/${companyId}`,
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function assignHeadManagers(
  headManagerId: number,
  headManagerCompanyId: number,
  managerIds: number[],
  managerCompanyIds: number[],
) {
  try {
    const response = await axios.post(
      `/api/users/assign-headmanagers`,
      {
        headManagerId,
        headManagerCompanyId,
        managerIds,
        managerCompanyIds,
      },
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return {
      isOk: true,
      data: response.data,
      message:
        response.data.message ||
        t("Managers successfully assigned to head manager."),
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function fetchManagersAssignedToHeadManager(
  headManagerId: number,
  companyId: number,
) {
  try {
    const { data } = await axios.get(
      `/api/users/headmanagers/${headManagerId}/${companyId}/managers`,
    );

    return { isOk: true, data };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function removeManagerFromHeadManager(
  headManagerId: number,
  companyId: number,
  managerId: number,
  managerCompanyId: number,
) {
  try {
    const { data } = await axios.delete(
      `/api/users/headmanagers/${headManagerId}/${companyId}/remove/${managerId}/${managerCompanyId}`,
    );

    return { isOk: true, data };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function getUserProjects(id: number) {
  try {
    const { data } = await axios.get<Project[]>(`/api/users/${id}/projects`, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return data;
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        }
        if (error.response.status === 404) {
          message = t("administrationPanel.userProjectsPopup.notFound");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
}
